import React from 'react';
import { MEMBER_TYPES, ORIENT_LABELS_SHORT, ORIENT_SERVICE } from '../receptionConstants';
import { formatVisitDate, formatVisitTime, formatReceptionAgeAtVisit } from '../receptionFormatters';

function serviceLineClass(line) {
  const key = String(line || '').toUpperCase();
  if (key === ORIENT_SERVICE.DENTAL) return 'recv-service-line--dental';
  if (key === ORIENT_SERVICE.NURSING) return 'recv-service-line--nursing';
  return 'recv-service-line--medical';
}

function serviceLineLabel(line) {
  if (!line) return null;
  return ORIENT_LABELS_SHORT[line] || line;
}

export default function VisitHistoryTableRows({ rows }) {
  return rows.map((r) => {
    const patientName = `${r.member_prenom || ''} ${r.member_nom || ''}`.trim() || '—';
    const metaParts = [
      r.member_matricule ? `Mat. ${r.member_matricule}` : null,
      MEMBER_TYPES[r.member_type] || r.member_type,
      formatReceptionAgeAtVisit(r.member_age_at_visit)
    ].filter(Boolean);
    const siteDossier =
      r.consultation_site_name &&
      r.visit_site_name &&
      r.consultation_site_name !== r.visit_site_name
        ? r.consultation_site_name
        : null;
    const lineLabel = serviceLineLabel(r.service_line);

    return (
      <article key={r.id} className="recv-journal-row" role="listitem">
        <div className="recv-journal-row__time recv-journal-list__cell recv-journal-list__cell--time">
          <span className="recv-journal-row__date">{formatVisitDate(r.registered_at)}</span>
          <span className="recv-journal-row__hour font-monospace">{formatVisitTime(r.registered_at)}</span>
        </div>
        <div className="recv-journal-row__patient recv-journal-list__cell recv-journal-list__cell--patient">
          <div className="recv-journal-row__name" title={patientName}>
            {patientName}
          </div>
          {metaParts.length > 0 ? (
            <div className="recv-journal-row__meta" title={metaParts.join(' · ')}>
              {metaParts.join(' · ')}
            </div>
          ) : null}
          {r.company_name ? (
            <div className="recv-journal-row__company" title={r.company_name}>
              {r.company_name}
            </div>
          ) : null}
        </div>
        <div className="recv-journal-row__site recv-journal-list__cell recv-journal-list__cell--site">
          <span className="recv-journal-row__site-label">Site</span>
          <span className="recv-journal-row__site-value">{r.visit_site_name || '—'}</span>
        </div>
        <div className="recv-journal-row__consult recv-journal-list__cell recv-journal-list__cell--consult">
          <div className="recv-journal-row__consult-main">
            <span className="recv-journal-consult__id font-monospace">
              {r.consultation_id ? `#${r.consultation_id}` : '—'}
            </span>
            {lineLabel ? (
              <span
                className={`recv-service-line recv-service-line--compact ${serviceLineClass(r.service_line)}`}
              >
                {lineLabel}
              </span>
            ) : null}
          </div>
          {siteDossier ? (
            <span className="recv-journal-row__dossier" title={`Dossier : ${siteDossier}`}>
              Dossier {siteDossier}
            </span>
          ) : null}
        </div>
        <div className="recv-journal-row__staff recv-journal-list__cell recv-journal-list__cell--staff">
          <span className="recv-journal-row__staff-label">Accueil</span>
          <span className="recv-journal-row__staff-value">{r.registered_by_name || '—'}</span>
        </div>
      </article>
    );
  });
}
